import { render, staticRenderFns } from "./BusinessDetailV2.vue?vue&type=template&id=5aea1d96&scoped=true"
import script from "./BusinessDetailV2.vue?vue&type=script&lang=js"
export * from "./BusinessDetailV2.vue?vue&type=script&lang=js"
import style0 from "./BusinessDetailV2.vue?vue&type=style&index=0&id=5aea1d96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aea1d96",
  null
  
)

export default component.exports